import { COUNTRIES, WARD_DISTRICT_REGIONS } from "./data";

export const inventoryFormFields = [
  {
    key: "warehouseId",
    label: "Warehouse",
    type: "select",
    placeholder: "Select warehouse",
    isRequired: true,
    options: [], // Will be populated dynamically
  },
  {
    key: "itemCode",
    label: "Item Code",
    type: "text",
    placeholder: "Enter item code",
    isRequired: false,
  },
  {
    key: "description",
    label: "Description",
    type: "text",
    placeholder: "Enter item description",
    isRequired: true,
  },
  {
    key: "unitWeight",
    label: "Unit Weight (KG)",
    type: "text",
    inputType: "number",
    placeholder: "Enter unit weight",
    isRequired: false,
  },
  {
    key: "length",
    label: "Length",
    type: "text",
    placeholder: "Enter length",
    isRequired: false,
  },
  {
    key: "value",
    label: "Unit Value",
    type: "text",
    inputType: "number",
    placeholder: "Enter unit value",
    isRequired: false,
  },
  {
    key: "hireRatePerWeek",
    label: "Hire Rate / Week",
    type: "text",
    inputType: "number",
    placeholder: "Enter hire rate per week",
    isRequired: false,
  },
  {
    key: "availableQuantity",
    label: "Available Quantity",
    type: "text",
    inputType: "number",
    placeholder: "Enter available quantity",
    isRequired: false,
  },
  {
    key: "rentedQuantity",
    label: "Rented Quantity",
    type: "text",
    inputType: "number",
    placeholder: "Enter rented quantity",
    isRequired: false,
  },
  {
    key: "reservedQuantity",
    label: "Reserved Quantity",
    type: "text",
    inputType: "number",
    placeholder: "Enter reserved quantity",
    isRequired: false,
  },
  {
    key: "damagedQuantity",
    label: "Damaged Quantity",
    type: "text",
    inputType: "number",
    placeholder: "Enter damaged quantity",
    isRequired: false,
  },
  {
    key: "lostQuantity",
    label: "Lost Quantity",
    type: "text",
    inputType: "number",
    placeholder: "Enter lost quantity",
    isRequired: false,
  },
  {
    key: "soldQuantity",
    label: "Sold Quantity",
    type: "text",
    inputType: "number",
    placeholder: "Enter sold quantity",
    isRequired: false,
  },
];

export const siteFormFields = [
  {
    key: "customer_name",
    label: "Customer Name",
    type: "auto-suggestion",
    placeholder: "Eg: District, Region",
    isRequired: true,
    suggestions: [
      "John Doe - Individual - Ubungo,Dar es Salaam",
      "Dproz - Company - Ubungo,Dar es Salaam",
    ],
  },
  {
    key: "site_name",
    label: "Site Name",
    type: "text",
    placeholder: "Enter site name",
    isRequired: true,
  },
  {
    key: "site_street",
    label: "Site Street",
    type: "text",
    placeholder: "Enter site street",
    isRequired: true,
  },
  {
    key: "location",
    label: "Location",
    type: "auto-suggestion",
    placeholder: "Eg: District, Region",
    isRequired: true,
    suggestions: WARD_DISTRICT_REGIONS,
  },
  {
    key: "status",
    label: "Status",
    type: "radio-group",
    placeholder: "Select status",
    className: "grid-cols-2",
    isRequired: true,
    options: [
      {
        label: "Active",
        value: "ACTIVE",
        description: "Busy storage facility",
      },
      {
        label: "Not Active",
        value: "INACTIVE",
        description: "Idle storage facility",
      },
    ],
  },
];

export const usersFormFields = [
  {
    key: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter user name",
    isRequired: true,
  },
  {
    key: "email",
    label: "Email",
    type: "text",
    placeholder: "Enter email",
    isRequired: true,
  },
  {
    key: "phone",
    label: "Phone Number",
    type: "text",
    placeholder: "Enter phone number",
    isRequired: true,
  },
  {
    key: "street",
    label: "Street",
    type: "text",
    placeholder: "Enter street",
    isRequired: false,
  },
  {
    key: "location",
    label: "Location",
    type: "auto-suggestion",
    placeholder: "Eg: Ward, District, Region",
    isRequired: false,
    suggestions: WARD_DISTRICT_REGIONS,
  },
  {
    key: "role",
    label: "Role",
    type: "select",
    placeholder: "Select role",
    isRequired: true,
    options: [
      { label: "Admin", value: "ADMIN" },
      { label: "Operation", value: "OPERATION" },
      { label: "Warehouse", value: "WAREHOUSE" },
      { label: "Sales", value: "SALES" },
      { label: "Accountant", value: "ACCOUNTANT" },
      { label: "Management", value: "MANAGEMENT" },
    ],
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    placeholder: "Select status",
    isRequired: false,
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "Disabled", value: "DISABLED" },
    ],
  },
];

export const warehouseFormFields = [
  {
    key: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter warehouse name",
    isRequired: true,
  },
  {
    key: "street",
    label: "Street",
    type: "text",
    placeholder: "Enter street name",
    isRequired: true,
  },
  {
    key: "location",
    label: "Location",
    type: "auto-suggestion",
    placeholder: "Eg: District, Region",
    isRequired: true,
    suggestions: WARD_DISTRICT_REGIONS,
  },
  {
    key: "contact_name",
    label: "Contact Name",
    type: "text",
    placeholder: "Enter contact name",
    isRequired: true,
  },
  {
    key: "contact_phone_number",
    label: "Contact Phone Number",
    type: "text",
    placeholder: "Enter contact phone number",
    isRequired: true,
  },
  {
    key: "status",
    label: "Status",
    type: "radio-group",
    placeholder: "Select status",
    className: "grid-cols-2",
    isRequired: true,
    options: [
      {
        label: "Active",
        value: "ACTIVE",
        description: "Busy storage facility",
      },
      {
        label: "Not Active",
        value: "INACTIVE",
        description: "Idle storage facility",
      },
    ],
  },
];

export const individualCustomerFormFields = [
  {
    key: "type",
    label: "Customer Type",
    type: "radio-group",
    placeholder: "Select type",
    className: "grid-cols-2",
    isRequired: true,
    options: [
      {
        label: "Individual",
        value: "Individual",
        description: "Private retail customer",
      },
      {
        label: "Organization",
        value: "Organization",
        description: "Commercial retail customer",
      },
    ],
  },
  {
    key: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter customer name",
    isRequired: true,
  },
  {
    key: "street",
    label: "Street",
    type: "text",
    placeholder: "Enter street name",
    isRequired: true,
  },
  {
    key: "address",
    label: "Location",
    type: "auto-suggestion",
    placeholder: "Eg: Ward, District, Region",
    isRequired: true,
    suggestions: WARD_DISTRICT_REGIONS,
  },
  {
    key: "phone_number",
    label: "Phone Number",
    type: "text",
    placeholder: "Enter customer phone number",
    isRequired: true,
  },
  {
    key: "postal_code",
    label: "Postal Code",
    type: "text",
    placeholder: "Enter postal code",
    isRequired: true,
  },
  {
    key: "tin",
    label: "TIN",
    type: "text",
    placeholder: "Enter TIN",
    isRequired: true,
  },
  {
    key: "vrn",
    label: "VRN",
    type: "text",
    placeholder: "Enter VRN",
    isRequired: true,
  },
];

export const organizationCustomerFormFields = [
  {
    key: "type",
    label: "Customer Type",
    type: "radio-group",
    placeholder: "Select type",
    className: "grid-cols-2",
    isRequired: true,
    options: [
      {
        label: "Individual",
        value: "Individual",
        description: "Private retail customer",
      },
      {
        label: "Organization",
        value: "Organization",
        description: "Commercial retail customer",
      },
    ],
  },
  {
    key: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter customer name",
    isRequired: true,
  },
  {
    key: "street",
    label: "Street",
    type: "text",
    placeholder: "Enter street name",
    isRequired: true,
  },
  {
    key: "address",
    label: "Location",
    type: "auto-suggestion",
    placeholder: "Eg: Ward, District, Region",
    isRequired: true,
    suggestions: WARD_DISTRICT_REGIONS,
  },
  {
    key: "phone_number",
    label: "Phone Number",
    type: "text",
    placeholder: "Enter customer phone number",
    isRequired: true,
  },
  {
    key: "contact_name",
    label: "Contact Name",
    type: "text",
    placeholder: "Enter contact name",
    isRequired: true,
  },
  {
    key: "contact_phone_number",
    label: "Contact Phone Number",
    type: "text",
    placeholder: "Enter contact phone number",
    isRequired: true,
  },
  {
    key: "postal_code",
    label: "Postal Code",
    type: "text",
    placeholder: "Enter postal code",
    isRequired: true,
  },
  {
    key: "tin",
    label: "TIN",
    type: "text",
    placeholder: "Enter TIN",
    isRequired: true,
  },
  {
    key: "vrn",
    label: "VRN",
    type: "text",
    placeholder: "Enter VRN",
    isRequired: true,
  },
];

export const bankDetailFormFields = [
  {
    key: "bankName",
    label: "Bank Name",
    type: "text",
    placeholder: "Enter bank name",
    isRequired: true,
  },
  {
    key: "accountName",
    label: "Account Name",
    type: "text",
    placeholder: "Enter account holder name",
    isRequired: true,
  },
  {
    key: "accountNumber",
    label: "Account Number",
    type: "text",
    placeholder: "Enter account number",
    isRequired: true,
  },
  {
    key: "swiftCode",
    label: "SWIFT / BIC Code",
    type: "text",
    placeholder: "Optional SWIFT code",
    isRequired: false,
  },
  {
    key: "branchName",
    label: "Branch Name",
    type: "text",
    placeholder: "Optional branch name",
    isRequired: false,
  },
];

export const vendorFormFields = [
  {
    key: "name",
    label: "Vendor Name",
    type: "text",
    placeholder: "Enter vendor name",
    isRequired: true,
  },
  {
    key: "phone_number",
    label: "Phone Number",
    type: "text",
    placeholder: "Enter vendor phone number",
    isRequired: true,
  },
  {
    key: "email",
    label: "Email",
    type: "text",
    placeholder: "Enter vendor email",
    isRequired: false,
  },
  {
    key: "address",
    label: "Address",
    type: "text",
    placeholder: "Enter vendor address",
    isRequired: true,
  },
  {
    key: "country",
    label: "Country",
    type: "auto-suggestion",
    placeholder: "Enter vendor country",
    isRequired: true,
    suggestions: COUNTRIES,
  },
];
